<template>
  <div class="pagination-wrap">
    <el-pagination
      background
      :layout="layout"
      :total="total"
      :current-page.sync="curPage"
      @current-change="current_change"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="handleSizeChange"
      :hide-on-single-page="hideSiglePage"
    ></el-pagination>
  </div>
</template>
<script>
const pageSizeList = [10, 20, 30, 40, 50, 100]
export default {
  props: {
    total: Number,
    pageSize: Number,
    currentPage: Number,
    hideSiglePage: {
      type: Boolean,
      default: () => false,
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next",
    },
  },
  data() {
    return {
      pageSizeList,
      curPage: 1,
    };
  },
  methods: {
    handleSizeChange: function(pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
    current_change(page) {
      this.$emit("getCurrentPage", page);
      this.curPage = page;
    },
    changeCurrentPage() {
      this.curPage = 1;
    },
  },
  watch: {
    currentPage(value) {
      this.curPage = value;
    },
  },
};
</script>
<style lang="less" scoped>
.pagination-wrap {
  text-align: right;
  padding: 12px 0px;
  /deep/ .btn-prev,
  /deep/ .btn-next,
  /deep/ .el-pager .number {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.65);
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    &.active {
      border: none;
    }
  }
}
</style>
